import React from 'react';
import { Input, Button, CheckboxTable, Select, PaperClip, Tooltip } from 'components';
import { UserService } from 'services';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Globals, Constants, checkPermission } from 'utils';
import { EditIcon, CheckWhiteIcon } from 'assets/icons';

interface Props {
	onClose?: any;
	item?: any;
	onUpdate?: any;
	modules?: any;
}

class ModalView extends React.Component<Props> {

	state = {
		item: this.props.item
	}

	render() {
		const { item } = this.state;

		return (
			<div id="modal-view-plan">
				<div className="container-title">
					{
						item?.image && (
							<img className="image" src={ Constants.BASE_STORAGE + item?.image } />
						)
					}
					<div style={{ flex: 1 }}>
						<p className="name">{ item?.name }</p>
						{
							item?.year_price > 0 && (
								<p className="price"><span>{ Globals.formatMiles(item?.year_price) }</span> Anual</p>
							)
						}
					</div>
					{
						checkPermission(Constants.MODULES.USERS,'delete') && (
							<Tooltip title="Editar">
								<a className="link-icon" href="#" onClick={ (e: any) => this.props.onUpdate(e,item) }>
									<img src={ EditIcon } />
								</a>
							</Tooltip>
						)
					}
				</div>
				<table className="table">
					<thead>
						<tr>
							<th>Módulos</th>
							<th className="text-right"></th>
						</tr>
					</thead>
					<tbody>
						{
							this.props.modules[item?.year_price > 0 ? 'paid' : 'free']?.map((item: any) => {
								return (
									<tr>
										<td>
											<div className="check-container">
												<div className="check">
													<img src={ CheckWhiteIcon } />
												</div>
												<p>{ item?.name }</p>
											</div>
										</td>
										<td className="bold text-right">{ item?.value }</td>
									</tr>
								)
							})
						}
					</tbody>
				</table>
				<div className="text-center">
					<Button className="btn-close" type="button" onClick={ () => this.props.onClose() }>
						Cerrar
					</Button>
				</div>
			</div>
		)
	}
}

export default ModalView;